














import { Component, Mixins, Model, Prop, Ref } from 'vue-property-decorator';
import FileInputMixin from '@/components/common/input/FileInputMixin.vue';

export type FileNameRenderType = 'input' | 'text' | 'hidden';

@Component
export default class FileInput extends Mixins(FileInputMixin) {
  @Prop({ default: 'input' })
  private readonly fileNameRenderType!: FileNameRenderType;
  @Prop({ default: 'SEARCH_FILE' })
  private readonly findFileButtonName!: string;
  @Prop({ default: false })
  private readonly buttonStyle!: boolean;

  @Model('change') value!: File;

  @Ref()
  private readonly fileInput!: HTMLInputElement;

  public focus(): void {
    this.fileInput.focus();
  }

  public clearFile() {
    this.fileInput.value = '';
  }

  public resetFileName() {
    this.removeFile();
  }
}
